import { useMutation } from 'react-query';

import { useQueryParams } from '@/hooks';
import { request, useCurrentUserId, toastError } from '@/utils';

import { FeedArticleDetail } from '../types';
import { setQueryAllFeedDetailByArticleId } from './setQuery';

// 认证 Action
export const useArticleQuestActionVerify = ({
  id,
  action_id,
  refCode,
  privateToken,
}: {
  id: number;
  action_id: number;
  refCode?: string;
  privateToken?: string;
}) => {
  const currentAddress = useCurrentUserId();

  return useMutation(
    async () => {
      const { is_success } = await request.post<{ is_success: boolean }>('/quest/action/verify', {
        id: action_id,
        ref_code: refCode ? Number(refCode) : undefined,
        private_token: privateToken,
      });

      if (!is_success) {
        return Promise.reject({ error_msg: 'Failed to verify' });
      }

      return request.get<FeedArticleDetail>('/article', {
        id,
        private_token: privateToken,
      });
    },
    {
      onSuccess(res) {
        const recipe = (pre?: FeedArticleDetail) => {
          if (pre?.article && res?.article) {
            Object.assign(pre.article, res.article);
          }
        };

        setQueryAllFeedDetailByArticleId({
          currentAddress: currentAddress!,
          articleId: id,
          recipe,
          includeQuote: true,
        });
      },
    },
  );
};

// 记录 url 点击
export const useArticleQuestActionVisit = (id: number) => {
  const [privateToken] = useQueryParams<string>('private_token');
  return useMutation(
    async () => {
      return await request.post<{ is_success: boolean }>('/quest/action/visit_url', {
        id,
        private_token: privateToken,
      });
    },
    {
      onError(err: any) {
        toastError(err || 'Failed');
      },
    },
  );
};
